var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_580_25986",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_580_25986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 16C8.325 16 6.90625 15.4187 5.74375 14.2563C4.58125 13.0938 4 11.675 4 10C4 8.325 4.58125 6.90625 5.74375 5.74375C6.90625 4.58125 8.325 4 10 4C10.8625 4 11.6875 4.17813 12.475 4.53438C13.2625 4.89062 13.9375 5.4 14.5 6.0625V4.75C14.5 4.5375 14.5719 4.35938 14.7156 4.21562C14.8594 4.07187 15.0375 4 15.25 4C15.4625 4 15.6406 4.07187 15.7844 4.21562C15.9281 4.35938 16 4.5375 16 4.75V8.5C16 8.7125 15.9281 8.89062 15.7844 9.03438C15.6406 9.17812 15.4625 9.25 15.25 9.25H11.5C11.2875 9.25 11.1094 9.17812 10.9656 9.03438C10.8219 8.89062 10.75 8.7125 10.75 8.5C10.75 8.2875 10.8219 8.10938 10.9656 7.96562C11.1094 7.82187 11.2875 7.75 11.5 7.75H13.9C13.5 7.05 12.9531 6.5 12.2594 6.1C11.5656 5.7 10.8125 5.5 10 5.5C8.75 5.5 7.6875 5.9375 6.8125 6.8125C5.9375 7.6875 5.5 8.75 5.5 10C5.5 11.25 5.9375 12.3125 6.8125 13.1875C7.6875 14.0625 8.75 14.5 10 14.5C10.8625 14.5 11.6594 14.2719 12.3906 13.8156C13.1219 13.3594 13.6687 12.75 14.0312 11.9875C14.0938 11.85 14.1969 11.7344 14.3406 11.6406C14.4844 11.5469 14.6313 11.5 14.7812 11.5C15.0688 11.5 15.2844 11.6 15.4281 11.8C15.5719 12 15.5875 12.225 15.475 12.475C15 13.5375 14.2688 14.3906 13.2812 15.0344C12.2937 15.6781 11.2 16 10 16Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.fa5125fd2443791363854c86efeef9a0.svg";
export { ForwardRef as ReactComponent };